import React from 'react';
import { Container } from '@infoods/lifebase-ui';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';

import classes from './NgzNutritionHome.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { BannerWidget } from '../../containers/BannerWidget/BannerWidget';
import { SOLUTION_TYPE } from '../../../shared/constants/user-info/solutionType';
import { InsightsWidget } from '../../containers/InsightsWidget/InsightsWidget';
import { RequiredAttentionWidget } from '../../containers/RequiredAttentionWidget/RequiredAttentionWidget';
import { CustomerSuccessWidget } from './components/CustomerSuccessWidget/CustomerSuccessWidget';
import { CustomerAnalyticsWidget } from './components/CustomerAnalyticsWidget/CustomerAnalyticsWidget';

const NgzNutritionHome = () => {
  return (
    <Container>
      <div className={classes.content}>
        <div className={classes.row}>
          <BannerWidget solutionType={SOLUTION_TYPE.NUTRITION} />
          <CustomerSuccessWidget />
        </div>
        <div className={classes.row}>
          <CustomerAnalyticsWidget />
          <InsightsWidget solutionType={SOLUTION_TYPE.NUTRITION} />
        </div>
        <RequiredAttentionWidget
          solutionType={SOLUTION_TYPE.NUTRITION}
          unreadScansTableMode="NUTRITION"
          paymentIssueTableMode="NUTRITION"
          showPreRegisteredTable
          titleIcon={<EditNoteOutlinedIcon fontSize="small" />}
        />
      </div>
    </Container>
  );
};

angularizeWithProviders(NgzNutritionHome, 'ngzNutritionHome', {});
